<template>
	<div class="section-howto padding-top-70">
		<section-title component-class="margin-bottom-50">
			<h2>
				<span class="fw-400">{{ $t('Section.HowToContainerSentence1') }}</span>
				{{ $t('Section.HowToContainerSentence2') }}
			</h2>
			<p v-if="!isUserAccount" v-html="$t('Section.HowToContainerSentence3Lawyer')"></p>
			<p
				v-else
				v-html="$t('Section.HowToContainerSentence3User', ['/registrazione-utente?redirect_to=/request/create/1'])"
			></p>
		</section-title>
		<div class="container">
			<div class="row">
				<div v-if="!isUserAccount" v-html="$t('Section.HowToContainerSentence4Lawyer')"></div>
				<div v-else v-html="$t('Section.HowToContainerSentence4User')"></div>
			</div>
			<div class="row margin-bottom-50">
				<p class="text-center">
					<span v-html="$t('Section.HowToContainerSentence5')"></span>&nbsp;
					<a href="#" @click.prevent="openHelpModal">{{ $t('Action.ToClickHere') }}</a>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
import SectionTitle from '@/components/partials/SectionTitle'

export default {
	name: 'HowToContainer',
	components: {
		SectionTitle,
	},
	mixins: [AccountInfo],
	methods: {
		openHelpModal() {
			// Emit open info modal event
			this.$root.$emit('open-help-modal', { name: 'success-fee' })
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/HowToContainer.vue